import React from 'react';
import { Menu } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { Link, Main } from 'components/layout';

const items = [
  {
    label: 'Bulk Download',
    key: 'bulk-download',
    icon: <AppstoreOutlined />,
  },
  {
    label: 'Funding Applications',
    key: 'funding-applications',
    icon: <AppstoreOutlined />,
  },
];

const OtherReports = () => {
  return (
    <Main>
      <PageContainer header={{ title: 'Other Reports' }} ghost>
        <Menu>
          {items.map((item) => (
            <Menu.Item key={item.key} icon={item.icon}>
              <Link to={`/other-reports/${item.key}`}>{item.label}</Link>
            </Menu.Item>
          ))}
        </Menu>
      </PageContainer>
    </Main>
  );
};

export default OtherReports;
